var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v("Stampe")])],1),_c('v-expansion-panels',_vm._l((_vm.stampe.filter(x => x.nomeReport && !x.nascondiSuElenco)),function(item,index){return _c('report',{key:index,attrs:{"report":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }